import { createRoot } from 'react-dom/client';
import App from './App';

export default function init() {
    const rootNode = document.getElementById('app-mount');
    const root = createRoot(rootNode!);

    renderApp();

    if (module.hot) {
        module.hot.accept('./App', renderApp);
    }

    function renderApp() {
        root.render(<App />);
    }
}
